import { type ReactNode } from 'react';
import { notification } from 'antd';

export namespace Toast {
  export enum Type {
    Error = 'error',
    Success = 'success',
  }
  type Props = {
    type: Type;
    message?: string;
    description?: string | ReactNode;
    duration?: number;
  };

  export const show = (props: Props) => {
    const { type, message = '', description, duration = 3 } = props;
    // TODO: static method is deprecated, context holder may be required in future

    type === Toast.Type.Error &&
      notification.error({
        message,
        description,
        duration,
      });

    type === Toast.Type.Success &&
      notification.success({
        message,
        description,
        duration,
      });
  };
}
